export const forceToArray = <T>(
  input: T | T[],
): Array<T> => (Array.isArray(input) ? input : [input]);
